import React, { useContext, useState } from 'react';
import moglixLogo from '@assets/images/moglix.svg'
import loginBg from '@assets/images/login_background.png'
import { Toaster } from 'react-hot-toast';
import { useMsal } from '@azure/msal-react';
import { useNavigate } from 'react-router-dom';
import { UserContext } from '@contexts/UserContext';
import { triggerGaEvents } from '../common/gtag';
import { loginRequest } from '@auth/authConfig';
import toast from 'react-hot-toast';
import { MESSAGE } from '../config/mesage';
import Loader from "../common/loader";
import logo from '@assets/images/microsoft_logo.png'
import AuthService from '../services/auth-service';

export default function Login() {

  const { instance } = useMsal();
  const navigate = useNavigate();
  const { user, setUser } = useContext(UserContext);
  const [loading, setLoading] = useState(false);

  const handleLogin = async () => {
    triggerGaEvents('login-clicked');
    try {
      setLoading(true);
      const response = await instance.loginPopup(loginRequest);
      if (!response?.accessToken) {
        toast.error(MESSAGE.ERROR.LOGIN_FAILED);
        setLoading(false);
        return;
      }
      AuthService.setMSToken(response.accessToken);
      const user = await AuthService.login(response.accessToken);
      if (user?.email) {
        updateUserDetails(user);
      } else {
        const claims = response.idTokenClaims || {};
        const email = (claims.email || claims.preferred_username || '').toLowerCase();
        const fullName = (claims.name || '').trim();
        const [firstName = '', ...rest] = fullName.split(' ');
        const lastName = rest.join(' ');
        const msUser = { email, firstName, lastName };
        updateUserDetails(msUser);
      }
      setLoading(false);
    } catch (error) {
      toast.error(MESSAGE.ERROR.LOGIN_FAILED);
      setLoading(false);
    }
  };

  const updateUserDetails = (user) => {
    AuthService.setGaId(user.email);
    setUser(user);
    triggerGaEvents('login-success');
    navigate('/');
  }

  return (
    <>
      {loading && <Loader />}
      <Toaster position="top-center" reverseOrder={false} /><div className="relative bg-cover bg-no-repeat bg-center h-screen" style={{ backgroundImage: `url(${loginBg})` }}>
        <div className="mobile:w-[330px] mobile:m-auto  w-[400px] bg-white shadow-lg border border-gray-300 rounded-lg absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 text-center flex flex-col box-border p-6 text-gray-700">
          <img className='m-auto' height={30} width={90} alt="moglix logo" src={moglixLogo} />
          <span className="mobile:text-[18px] mobile:mb-0 mobile:mt-4  text-[28px] inline-block text-gray-700 font-medium mt-2">Unified Platform </span>
          <button onClick={handleLogin}>
            <span className="bg-red-600 mobile:mt-[15px] flex items-center justify-center rounded-md border-none px-4 py-3 cursor-pointer relative mt-7 font-semibold text-xs text-white"  >
              <img className="text-[20px] text-white mr-2" alt="microsoft logo" src={logo} />
              Login with Microsoft
            </span>
          </button>
          <span className="text-[12px] leading-[18px] font-normal text-black pt-2">This workspace allows you to sign in with your moglix email ID</span>
        </div>
      </div>
    </>
  )
}
